export default __webpack_public_path__ + "static/media/Gutstrap.545f1e89.jpg";